const localUrl = `${import.meta.env.VITE_BASE_URL}/`;
// const localUrl = `https://back.mymedassistnetwork.com/`;
export const baseURL = import.meta.env.DEV ? localUrl : `${import.meta.env.VITE_BASE_URL}/`;

// export const baseURL = `https://back.mymedassistnetwork.com/`;

// export const baseURL = `https://med-back-5et2f.ondigitalocean.app/`;

export const AUTH_URL = baseURL + 'auth';
export const PROFILE_URL = baseURL + 'profile';

// export const ADDRESSES_URL = baseURL + 'addresses';

// export const CLIENTS_URL = baseURL + 'clients';
// export const INCIDENTS_URL = baseURL + 'incidents';
// export const INSURANCE_COMPANIES_URL = baseURL + 'insurance-companies';
// export const AIR_AMBULANCES_URL = baseURL + 'air-ambulances';
// export const DIAGNOSTICS_URL = baseURL + 'diagnostics';
// export const DOCTORS_URL = baseURL + 'doctors';
// export const GROUND_AMBULANCES_URL = baseURL + 'ground-ambulances';
// export const SYMPTOMS_URL = baseURL + 'symptoms';
// export const HCMS_URL = baseURL + 'hcms';
// export const NURSES_URL = baseURL + 'nurses';
// export const TAXIS_URL = baseURL + 'taxis';
// export const VIDEO_CALL_URL = baseURL + 'video-call';
// export const USERS_URL = baseURL + 'users';
// export const AVAILABILITIES_URL = baseURL + 'availabilities';

export const MEETINGS_URL = baseURL + 'meetings';
